import React, { Component, Fragment } from 'react';

import intl from 'react-intl-universal';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';
import DeleteIcon from '@mui/icons-material/Delete';


class DeleteVideo extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
        setOpen: false
        }
   
        this.deleterecord = this.deleterecord.bind(this)
      }

    
    handleClickOpen = (event) => {  
        this.setState ({
          setOpen: true
      })
    };

    handleClickClose = (event) => {  
        this.setState ({
          setOpen: false
      })
      
    };

    handle_delete_record (recordID) { 
      //console.log(recordID)
      this.deleterecord(recordID)
    }

    deleterecord (recordID)  {
        let apiurl = window.apiurl
        let token = this.props.token

        let json = "";
        json = '{';
        json += '"id": "' + recordID + '",';
        json += '}';  
        
        fetch("https://"+apiurl+"/api/Recording/"+recordID+"", {
            method: 'DELETE',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token,
            },
            body: json
          })
            .then(res => res.json())
            .then(json => {
              console.log("---------------")
              console.log(json)
              console.log("---------------")
              this.setState ({
                setOpen: false
             })
              this.props.handlefilterdateafterdelete()
              
            })
            .catch(function(error) {
                console.log(error.status);
              });         
          }

    render () {  
        
        return (
            <Fragment>
                <Alert severity="warning">
               <Button variant="outlined" onClick={this.handleClickOpen} startIcon={<DeleteIcon />} color="error">
               {intl.get('REC_DELETE_BUTTON')}
                </Button>
                </Alert>
                <Dialog
                open={this.state.setOpen}
                onClose={this.handleClickClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
        <DialogTitle id="alert-dialog-title">
          {intl.get('REC_DELETE_DIALOG_HEAD')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {intl.get('REC_DELETE_DIALOG_CONT')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClickClose}>{intl.get('REC_DELETE_DIALOG_NO')}</Button>
          <Button onClick={() => this.handle_delete_record(this.props.videoid)} autoFocus>
          {intl.get('REC_DELETE_DIALOG_YES')}
          </Button>
        </DialogActions>
      </Dialog>
              
            </Fragment>
        )
    }
}


export default DeleteVideo;